import { Icons } from '@/utils/Icons';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import UserDropdown from './UserDropdown';
import Navbar from '@/components/Navbar';
import HeaderTopGames from './HeaderTopGames';
import MobileNavbar from '@/components/MobileNavbar';
import { useState } from 'react';
import SetButtonValueModal from './SetButtonValueModal';
import RulesModal from '@/components/RulesModal';
import { useAppDispatch, useAppSelector } from '@/hooks';
import { setAgeModalOpen, setRulesModalOpen } from '@/store/slices/uiSlice';
import AgeRestrictionModal from '@/components/AgeRestrictionModal';
import Marquee from '@/components/Marquee';
import { useGetUserInfoQuery, useGetUserWalletsQuery } from '@/store/api/userApi';
import SearchDropdown from '@/components/common/SearchDropdown';

const Header = ({ onMenuClick }: { onMenuClick: () => void }) => {
  const [showSearch, setShowSearch] = useState(false);
  const [showBalance, setShowBalance] = useState(true);
  const [showExposure, setShowExposure] = useState(true);
  const location = useLocation();
  const reportsPage = location.pathname.includes('user');
  const isHomePage = location.pathname.includes('home');
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { ageModalOpen } = useAppSelector((state) => state.ui);

  useGetUserInfoQuery(undefined, { pollingInterval: 5000 });
  useGetUserWalletsQuery(undefined, { pollingInterval: 5000 });

  const { info, walletInfo } = useAppSelector((state) => state.user);
  const username = info?.username ?? 'Demo';
  const isDemoUser = info?.role?.name?.toLowerCase() == 'demo';
  const mainWallet = walletInfo?.find((item) => item?.type == 'Main');
  const mainBalance =
    Number(mainWallet?.amount ?? 0) -
    Math.abs(Number(mainWallet?.exposureAmount ?? 0)) -
    Number(mainWallet?.lockedAmount ?? 0);

  const exposure = mainWallet?.exposureAmount;

  const handleBalanceChange = (value: boolean) => {
    setShowBalance(value);
  };

  const handleExposureChange = (value: boolean) => {
    setShowExposure(value);
  };

  return (
    <div className="bg-primary">
      {/* Header Top */}
      <section className="max-xl:p-[5px] max-xl:pt-[5px] xl:px-2 xl:py-1">
        <div className="flex justify-between relative items-center">
          {/* Logo */}
          <div className="flex items-center space-x-2">
            {isHomePage ? (
              <Icons.Menu
                onClick={() => onMenuClick()}
                className="xl:hidden text-[20px] text-white"
              />
            ) : (
              <Icons.Home
                onClick={() => navigate('/home')}
                className="xl:hidden text-[20px] text-white"
              />
            )}
            <Link to="/home">
              <img
                className="max-h-[35px] max-w-[120px] xl:max-h-[65px] xl:max-w-[250px]"
                src="/images/logo/logo.png"
                alt=""
              />
            </Link>
          </div>
          {/* Details */}
          <div className="hidden xl:flex items-center text-white space-x-4">
            <SearchDropdown variant="compact" />
            <div style={{ lineHeight: 'normal' }} className="text-base font-bold">
              <div className="cursor-pointer" onClick={() => dispatch(setRulesModalOpen(true))}>
                Rules
              </div>
              <div className="flex items-center">
                <span>Download Apk</span>
                <Icons.Android />
              </div>
            </div>
            {/* Balance Info */}
            <div style={{ lineHeight: 'normal' }}>
              <div>
                <span>Balance:</span>
                <b>{mainBalance}</b>
              </div>
              <div style={{ lineHeight: 'normal' }}>
                <span>Exp:</span>
                <b>{exposure}</b>
              </div>
            </div>
            <div>
              <UserDropdown
                isDemoUser={isDemoUser}
                showBalance={showBalance}
                showExposure={showExposure}
                handleBalanceChange={handleBalanceChange}
                handleExposureChange={handleExposureChange}
                username={username}
              />
            </div>
          </div>
          {/* Mobile Details */}
          <div className="flex flex-col text-white xl:hidden">
            {showBalance && (
              <span className="text-xs text-end md:text-base px-1 py-[2px]">
                Balance:<b>{Number(mainBalance).toFixed(2)}</b>
              </span>
            )}
            <div className="flex items-center space-x-[5px] px-1 py-[2px]">
              {showExposure && (
                <span className="text-xs md:text-base">
                  Exp:<b>{exposure}</b>
                </span>
              )}
              <UserDropdown
                isDemoUser={isDemoUser}
                showBalance={showBalance}
                showExposure={showExposure}
                handleBalanceChange={handleBalanceChange}
                handleExposureChange={handleExposureChange}
                username={username}
              />
            </div>
          </div>
        </div>
        <div className={'flex justify-end'}>
          <Marquee />
        </div>
        <div className="xl:hidden flex items-center gap-1">
          <SearchDropdown variant="compact" />
          {/* <div className="whitespace-nowrap overflow-hidden py-[3px] flex-1 text-body-inverse text-sm italic bg-danger-coral">
            Newly Launched Matka Market in Our Exchange
          </div> */}
          <Marquee type="mobile" />
        </div>
      </section>

      {/* Header Bottom */}
      <section>
        {!reportsPage && (
          <>
            {' '}
            <HeaderTopGames />
            <MobileNavbar />
            <Navbar />{' '}
          </>
        )}
        <SetButtonValueModal />
        <RulesModal />
        <AgeRestrictionModal open={ageModalOpen} onClose={() => dispatch(setAgeModalOpen(false))} />
      </section>
    </div>
  );
};

export default Header;
